export default __webpack_public_path__ + "static/media/4bdf113f1d9bb1ac67a738ae4378e942.svg";